import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: LitTableView UI Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.littable-view.';

  public static readonly filter = `${Id.prefix}filter`;
  public static readonly textSearch = `${Id.prefix}textSearch`;
}

export class LangLitTableView {
  private constructor() {}
  public static filter(): string {
    return interpolate(Id.filter);
  }
  public static textSearch(): string {
    return interpolate(Id.textSearch);
  }
}

export class LitTableViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // LitTableView UI Strings
    register.add(Id.filter, 'Filter', 'Label for the filter input in a table');
    register.add(Id.textSearch, 'Text Search', 'Placeholder for the filter input in a table');
  }
}
